import { Card } from '@fl/cmsch-fe-library';
import React, { FC, memo, useMemo } from 'react';
import { Content } from 'app/content';
import { useOurTranslation } from 'app/translations';
import { ConnectedScreenHeader } from 'common/layout';
import { UsersTable } from '../components/users-table';
const UsersBase: FC = _ => {
  const {
    t
  } = useOurTranslation('admin');
  const header = useMemo(() => <ConnectedScreenHeader title={t('users')} />, [t]);
  return <Content browserTabTitle={t('users')} data-sentry-element="Content" data-sentry-component="UsersBase" data-sentry-source-file="users.tsx">
            <Card title={header} titleSize="medium" noWhiteSpaceBody data-sentry-element="Card" data-sentry-source-file="users.tsx">
                <UsersTable data-sentry-element="UsersTable" data-sentry-source-file="users.tsx" />
            </Card>
        </Content>;
};

/** Admin users screen. */
export const Users = memo(UsersBase);